/* Buffelh store: shared behaviour. Phone menu drawer, cart count, add to cart for every [data-bx-add] form,
   notify form checks. Plain JavaScript, no libraries. Loaded with defer from snippets/bx-head.liquid. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- cart count ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-bx-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-bx-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
    document.querySelectorAll('[data-bx-drawer-cart]').forEach(function (el) { el.textContent = 'Cart (' + n + ')'; });
  }
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }
  window.bxRefreshCount = refreshCount;
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  /* ---------- phone menu drawer (markup is printed by sections/bx-header.liquid) ---------- */
  var drawer = document.querySelector('[data-bx-drawer]');
  var openBtn = document.querySelector('[data-bx-menu-open]');
  if (drawer && openBtn) {
    var closeBtn = drawer.querySelector('[data-bx-menu-close]');
    var html = document.documentElement;
    var open = function () {
      drawer.classList.add('bx-open');
      openBtn.setAttribute('aria-expanded', 'true');
      html.classList.add('bx-lock');
      if (closeBtn) closeBtn.focus();
    };
    var close = function (back) {
      drawer.classList.remove('bx-open');
      openBtn.setAttribute('aria-expanded', 'false');
      html.classList.remove('bx-lock');
      if (back !== false) openBtn.focus();
    };
    openBtn.addEventListener('click', function () { drawer.classList.contains('bx-open') ? close() : open(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) close(false); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(drawer.querySelectorAll('a[href],button')).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 900 && drawer.classList.contains('bx-open')) close(false); });
  }

  /* ---------- add to cart: every form with data-bx-add (product page, ladder band, quick add, bundles) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bx-add], form[data-bx-quick]');
    if (!form || form.getAttribute('data-bx-busy')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-bx-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    form.setAttribute('data-bx-busy', '1');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var body = new FormData(form);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.d && (res.d.description || res.d.message)) || 'Could not add this to the cart. Try again.';
          if (err) { err.textContent = msg; err.hidden = false; } else { window.alert(msg); }
          return;
        }
        refreshCount();
        if (document.querySelector('[data-bx-cdrw-root]') && (form.getAttribute('data-after') !== 'stay' || form.closest('[data-bx-cdrw]'))) {
          document.dispatchEvent(new CustomEvent('bx:added', { detail: { form: form } }));
        } else if (form.getAttribute('data-after') === 'stay') {
          if (err) { err.textContent = 'Added to your cart.'; err.hidden = false; }
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { form.removeAttribute('data-bx-add'); form.removeAttribute('data-bx-quick'); form.submit(); })
      .then(function () {
        form.removeAttribute('data-bx-busy');
        if (btn) btn.removeAttribute('aria-busy');
      });
  });

  /* ---------- notify / sign-up forms: age box, consent box, email ---------- */
  document.querySelectorAll('[data-bx-notify] form').forEach(function (nf) {
    nf.addEventListener('submit', function (e) {
      var em = nf.querySelector('input[type="email"]');
      var boxes = nf.querySelectorAll('input[type="checkbox"]');
      if (!em) return;
      var bad = null;
      var okMail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value);
      var field = em.closest('.bx-field');
      var msg = field && field.querySelector('.bx-msg');
      if (field) field.classList.toggle('bx-err', !okMail);
      if (msg) msg.textContent = okMail ? '' : 'Enter an email address like name@example.com';
      if (!okMail) bad = em;
      boxes.forEach(function (b, i) {
        var wrap = b.closest('.bx-check');
        var em2 = wrap && wrap.querySelector('.bx-em');
        if (wrap) wrap.classList.toggle('bx-err', !b.checked);
        if (em2) em2.textContent = b.checked ? '' : (i === 0 ? 'Confirm you are 18 or older' : 'Tick the box to be notified');
        if (!b.checked && !bad) bad = b;
      });
      if (bad) { e.preventDefault(); bad.focus(); }
    });
  });
})();

/* ---------- cart drawer: loaded on demand with the Section Rendering API (sections/bx-cart-drawer.liquid) ---------- */
(function () {
  'use strict';
  var host = document.querySelector('[data-bx-cdrw-root]');
  if (!host) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var html = document.documentElement;
  var lastFocus = null;
  function panel() { return host.querySelector('.bx-cdrw-panel'); }
  function load() {
    return fetch(root + '?sections=bx-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j['bx-cart-drawer']) return false; host.innerHTML = j['bx-cart-drawer']; return true; })
      .catch(function () { return false; });
  }
  function isOpen() { var d = host.querySelector('[data-bx-cdrw]'); return !!(d && d.classList.contains('bx-open')); }
  function open() {
    lastFocus = document.activeElement;
    return load().then(function (ok) {
      if (!ok) { window.location.href = root + 'cart'; return; }
      var d = host.querySelector('[data-bx-cdrw]');
      requestAnimationFrame(function () { d.classList.add('bx-open'); });
      html.classList.add('bx-lock');
      var p = panel(); if (p) p.focus();
      if (window.bxRefreshCount) window.bxRefreshCount();
    });
  }
  function close() {
    var d = host.querySelector('[data-bx-cdrw]');
    if (d) d.classList.remove('bx-open');
    html.classList.remove('bx-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function reload() {
    return load().then(function () {
      var d = host.querySelector('[data-bx-cdrw]'); if (d) d.classList.add('bx-open');
      var p = panel(); if (p) p.focus();
      if (window.bxRefreshCount) window.bxRefreshCount();
    });
  }
  window.bxCartDrawer = { open: open, close: close, reload: reload };
  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t.closest && t.closest('[data-bx-cart-link]');
    if (link && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); return; }
    if (t.closest && t.closest('[data-bx-cdrw-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest && t.closest('[data-bx-cq]');
    if (q) {
      e.preventDefault(); q.disabled = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: +q.getAttribute('data-q') }) })
        .then(reload);
      return;
    }
    var sw = t.closest && t.closest('[data-bx-cswap]');
    if (sw) {
      e.preventDefault(); sw.disabled = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: sw.getAttribute('data-key'), quantity: 0 }) })
        .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +sw.getAttribute('data-to'), quantity: 1 }] }) }); })
        .then(reload);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var p = panel(); if (!p) return;
    var f = [].slice.call(p.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])')).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  /* after add to cart: open the drawer instead of going to the cart page; add-ons inside the drawer reload it */
  document.addEventListener('bx:added', function (e) {
    if (e.detail && e.detail.form && e.detail.form.closest('[data-bx-cdrw]')) { reload(); return; }
    open();
  });
})();
